import { FIELD_CONFIG } from '../constants/field-config.js'

export const getFieldConfig = (type) => {
  if(type in FIELD_CONFIG) {
    return FIELD_CONFIG[type]
  }
}